module.exports = __webpack_public_path__ + "static/media/parity.dd92e9e3.jpg";